import React from "react";
import Box from '@mui/material/Box';
import { styled } from '@mui/styles';
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

import { MuiAvatar } from "../../../components";

export default function ({ imageUrl = null, ownerName = null, ...props }) {
    return <StyledUserInfo {...props}>
        <Divider />
        <Stack className="Stack" direction="row" spacing={2} alignItems="center">
            <MuiAvatar src={imageUrl} fullName={ownerName} />
            <Typography>A fundraiser by {ownerName}</Typography>
        </Stack>
        <Divider />
    </StyledUserInfo>
}

const StyledUserInfo = styled(Box)(({ theme }) => ({
    '& .Stack': {
        padding: '10px 0',
    },

    '& .MuiDivider-root': {
        margin: '0'
    },
    '& .MuiAvatar-root': {
        width: '30px', 
        height: '30px'
    },

    '& .MuiTypography-root': {
        fontSize: '14px'
    }
}));